import Timeline from './Timeline';
import TimelineItem from './TimelineItem';
import TimelineItemGroup from './TimelineItemGroup';

Timeline.Item = TimelineItem;
Timeline.Group = TimelineItemGroup;
export default Timeline;
